import React from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  TableContainer,
  Paper,
  Link,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Cookies() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mx: "auto",
        width: "80vw",
      }}
    >
      <Typography variant="h4">{t("Πολιτική Cookies")}</Typography>
      <List sx={{ listStyle: "decimal", pl: 4 }}>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">{t("Τι είναι τα Cookies;")}</Typography>
              <Typography>
                {t(
                  "Τα cookies είναι μικρά αρχεία που εγκαθίστανται στον υπολογιστή ή άλλη συσκευή όταν επισκέπτεστε μια ιστοσελίδα. " +
                    "Χρησιμοποιούνται για τη λειτουργία της ιστοσελίδας που επισκέπτεστε καθώς και την παροχή πρόσθετης λειτουργικότητας " +
                    "(όπως ταυτοποίηση του χρήστη, απομνημόνευση των προτιμήσεων).",
                )}
              </Typography>
            </Box>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">
                {t(
                  "Για ποιο λόγο χρησιμοποιούνται τα cookies στην παρούσα ιστοσελίδα;",
                )}
              </Typography>
              <Typography>
                {t(
                  "Η ιστοσελίδα τοποθετεί cookies για τις κάτωθι λειτουργίες:",
                )}
              </Typography>
              <List
                sx={{
                  listStyle: "circle",
                  pl: 4,
                  lineHeight: 2,
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Typography>
                      {t("Βασικές λειτουργικότητες όπως:")}
                    </Typography>
                    <List sx={{ listStyle: "disc", pl: 4 }}>
                      <ListItemText sx={{ display: "list-item" }}>
                        {t(
                          "εμφάνιση ιστοσελίδας και αποθήκευση προτιμήσεων χρήστη (π.χ. επιλογή γλώσσας/ χρωμάτων, παρουσίαση αποτελεσμάτων αναζήτησης)",
                        )}
                      </ListItemText>
                      <ListItemText sx={{ display: "list-item" }}>
                        {t(
                          "ασφάλεια του επισκέπτη (π.χ. cookies που εντοπίζουν επαναλαμβανόμενες αποτυχημένες προσπάθειες εισόδου στον λογαριασμό ενός χρήστη)",
                        )}
                      </ListItemText>
                      <ListItemText sx={{ display: "list-item" }}>
                        {t("κατανομή φορτίου (load balancing)")}
                      </ListItemText>
                    </List>
                  </Box>
                </ListItem>
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "αναγνώριση ή/και διατήρηση περιεχομένου που εισάγει ο χρήστης κατά τη διάρκεια μίας σύνδεσης (session) καθ’ όλη τη διάρκεια της συγκεκριμένης σύνδεσης (π.χ. κατά τη συμπλήρωση μίας ηλεκτρονικής φόρμας κράτησης).",
                  )}
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "αυθεντικοποίηση του χρήστη σε υπηρεσίες που απαιτούν αυθεντικοποίηση (π.χ. κατά την πραγματοποίηση μίας τραπεζικής συναλλαγής μέσω του διαδικτύου)",
                  )}
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "Παροχή πολυμεσικού περιεχομένου όπως για παράδειγμα τα cookies που εγκαθίστανται με την προβολή ενός βίντεο.",
                  )}
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  {t("Διαμοιρασμός περιεχομένου μέσω κοινωνικών δικτύων.")}{" "}
                  (social media)
                </ListItemText>
              </List>
              <ListItemText>
                {t(
                  "Επίσης τρίτα μέρη τοποθετούν για λογαριασμό της παρούσας ιστοσελίδας cookies για τις κάτωθι λειτουργίες:",
                )}
              </ListItemText>
              <List
                sx={{
                  listStyle: "circle",
                  pl: 4,
                  lineHeight: 2,
                }}
              >
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "συλλογή στατιστικών στοιχείων σχετικά με την επισκεψιμότητα της ιστοσελίδας και τον τρόπο που οι επισκέπτες τη χρησιμοποιούν",
                  )}
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "προβολή διαφημίσεων (εντός ή και εκτός της ιστοσελίδας).",
                  )}
                </ListItemText>
              </List>
            </Box>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">
                {t("Ποια cookies εγκαθιστά η παρούσα ιστοσελίδα;")}
              </Typography>
              <Typography>
                {t(
                  "Η παρούσα ιστοσελίδα χρησιμοποιεί τις κάτωθι κατηγορίες cookies:",
                )}
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {t("Ονομασία Cookie")}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {t("Σκοπός")}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {t("Διάρκεια")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{t("gat")}</TableCell>
                      <TableCell>
                        {t(
                          "Το χρησιμοποιεί η Google για τα Google Analytics / στατιστικά στοιχεία κίνησης",
                        )}
                      </TableCell>
                      <TableCell>{t("1 λεπτό")}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">
                {t("Πώς μπορώ να διαχειριστώ τα cookies;")}
              </Typography>
              <Typography>
                {t(
                  "Όλοι οι φυλλομετρητές (web browsers) σας επιτρέπουν να διαχειριστείτε τα cookies προκειμένου είτε να διαγράψετε τα cookies μόλις ολοκληρώσετε την επίσκεψή σας στην ιστοσελίδα ή να ορίσετε τις προτιμήσεις σας όσον αφορά στη χρήση των cookies πριν ξεκινήσετε την περιήγηση στην ιστοσελίδα. Παρακαλούμε, σημειώστε ότι η διαγραφή ή η απόρριψη των cookies μπορεί να επηρεάσει αρνητικά την εμπειρία χρήσης της ιστοσελίδας (π.χ. κάποια χαρακτηριστικά να μην είναι πλήρως διαθέσιμα). Μπορείτε να βρείτε περισσότερες πληροφορίες για το φυλλομετρητή σας στους κάτωθι συνδέσμους:",
                )}
              </Typography>
              <List
                sx={{
                  listStyle: "circle",
                  pl: 4,
                  lineHeight: 2,
                }}
              >
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.google.com/chrome/answer/95647?hl=en"
                    target="_blank"
                  >
                    {t("Google Chrome")}
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                    target="_blank"
                  >
                    {t("Microsoft Edge")}
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.microsoft.com/en-us/topic/description-of-cookies-ad01aa7e-66c9-8ab2-7898-6652c100999d"
                    target="_blank"
                  >
                    {t("Microsoft Internet Explorer")}
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
                    target="_blank"
                  >
                    {t("Mozilla Firefox")}
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.apple.com/kb/ph21411?locale=en_US"
                    target="_blank"
                  >
                    {t("Apple Safari (Mac OS)")}
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.apple.com/en-us/HT201265"
                    target="_blank"
                  >
                    {t("Apple Safari (iPhone, iPad)")}
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                    target="_blank"
                  >
                    {t("Opera")}
                  </Link>
                </ListItemText>
              </List>
              <Typography>
                {" "}
                {t(
                  "Αν επιθυμείτε να απενεργοποιήσετε τα Google Analytics συνολικά, για κάθε σελίδα που επισκέπτεστε και όχι μόνον την παρούσα,",
                )}
                <Link
                  href="https://tools.google.com/dlpage/gaoptout"
                  target="_blank"
                >
                  {t("επισκεφθείτε τη σχετική σελίδα.")}
                </Link>
              </Typography>
            </Box>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">
                {t("Πού μπορώ να μάθω περισσότερα για τα cookies;")}
              </Typography>
              <Typography>
                {t(
                  "Αναλυτικές πληροφορίες για τη χρήση των cookies, καθώς και του τρόπου αποκλεισμού ή περιορισμού τους μπορείτε να βρείτε στις ιστοσελίδες:",
                )}
              </Typography>
              <List
                sx={{
                  listStyle: "circle",
                  pl: 4,
                  lineHeight: 2,
                }}
              >
                <ListItemText sx={{ display: "list-item" }}>
                  <Link
                    href="https://cookiepedia.co.uk/all-about-cookies"
                    target="_blank"
                  >
                    https://cookiepedia.co.uk/all-about-cookies
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link href="http://www.allaboutcookies.org/" target="_blank">
                    http://www.allaboutcookies.org/
                  </Link>
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  <Link href="https://www.aboutcookies.org/" target="_blank">
                    https://www.aboutcookies.org/
                  </Link>
                </ListItemText>
              </List>
            </Box>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">
                {t("Ενδέχεται να αλλάξει η παρούσα πολιτική;")}
              </Typography>
              <Typography>
                {t(
                  "Η παρούσα πολιτική δύναται να τροποποιηθεί οποιαδήποτε στιγμή και ισχύουσα θεωρείται πάντοτε η πιο πρόσφατη τροποποίηση. Σας προτείνουμε να ανατρέχετε τακτικά στην παρούσα σελίδα, η οποία τέθηκε σε ισχύ στις 11/07/2022.",
                )}
              </Typography>
              <Typography sx={{ textDecoration: "underline" }}>
                {t("Σημείωση")}
              </Typography>
              <Typography>
                {t(
                  "Η Κεντρική Ένωση Επιμελητηρίων ουδεμία ευθύνη φέρει για τις παραπομπές από την παρούσα πολιτική σε εξωτερικές ιστοσελίδες, για το περιεχόμενο και τις υπηρεσίες αυτών, το οποίο δεν ελέγχει ούτε υιοθετεί, και οιαδήποτε ζημία προκύψει από τη χρήση τους, καθώς ο επισκέπτης έχει πρόσβαση σε αυτές με δική του ευθύνη.",
                )}
              </Typography>
            </Box>
          </ListItemText>
        </ListItem>
      </List>
    </Box>
  );
}
